const INGREDIENT_KEYWORDS_TYPE_LEVELS = [1, 3, 5]

export default INGREDIENT_KEYWORDS_TYPE_LEVELS
